export const GridFeatureModeConstant = {
  client: 'client',
  server: 'server'
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/models/gridFeatureMode.js
// module id = 625
// module chunks = 25